import { ILoyaltyCustomer } from '../../interface/customer.interfaces';
import * as constants from './constants';

export interface ILoyaltyInitialState {
  isLoyaltyProgramActive: boolean;
  isAstrapayConnected: string;
  astrapayBalance: ILoyaltyCustomer;
  astrapointsValue: string;
}

const INITIAL_STATE: ILoyaltyInitialState = {
  isLoyaltyProgramActive: false,
  astrapointsValue: '',
  isAstrapayConnected: '',
  astrapayBalance: {
    astraPointsFormatted: '',
    astraPointsValue: 0,
    formatterValue: '',
    value: 0,
  },
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_IS_LOYALTY_PROGRAM_ACTIVE:
      return { ...state, isLoyaltyProgramActive: action.payload };
    case constants.SET_IS_ASTRAPAY_CONNECTED:
      return { ...state, isAstrapayConnected: action.payload };
    case constants.SET_ASTRAPPOINTS_VALUE:
      return { ...state, astrapointsValue: action.payload };
    case constants.SET_ASTRAPAY_BALANCE:
      return { ...state, astrapayBalance: action.payload };

    default:
      return state;
  }
};

export default exportedObject;
